const routes = [
  {
    // 宿迁民丰加油满减活动页 - 首页
    path: '/minfengBankSuqianRefuel',
    name: 'minfengBankSuqianRefuel',
    component: () => import('@/views/minfengBank/suqianRefuel/index.vue'),
    meta: {
      requiresAuth: true,
      title: '民丰银行'
    }
  },
]

export default routes
